import { useQuery } from "@tanstack/react-query";
import { getBapLogByPayRef } from "../../service/query/auth";

export const useGetBapLogByPayRef = ({ payment_ref, enabled }) => {
    return useQuery({
        queryKey: ["bapLogByPayRef", payment_ref],
        queryFn: () => getBapLogByPayRef(payment_ref),
        enabled: !!enabled && !!payment_ref,
    });
};